import { render } from "./iconSearchV2.vue?vue&type=template&id=20e98e92"
import script from "./iconSearchV2.vue?vue&type=script&lang=js"
export * from "./iconSearchV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__